import { type Maybe } from '@gql/graphql';
import { isDefined } from '@utils/isDefined';
import { type NodesOf } from '../models';

export function toNodes<C>(conn: Maybe<C>): NodesOf<C> {
    const edges = (conn as any)?.edges as Maybe<({ node?: unknown } | null)[]>;
    return (edges ?? []).map((e) => e?.node).filter(isDefined) as any;
}
